<template>
	<c-typography
		v-linkify:options="{ className: 'linkified' }"
		:type="contentItems[type].type"
		:element="contentItems[type].element"
		:color="computedColor"
		:class="`content--${type}`"
	>
		<slot />
	</c-typography>
</template>

<script>
import linkify from 'vue-linkify';

export default {
	name: 'CommonContent',
	props: {
		type: {
			type: String,
			default: 'body',
		},
		color: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			contentItems: {
				overline: { type: 'caption1', element: 'p', color: 'gray400' },
				title: { type: 'headline7', element: 'h2', color: 'gray900' },
				body: { type: 'body1', element: 'p', color: 'gray850' },
				caption: { type: 'body2', element: 'p', color: 'gray300' },
			},
		};
	},
	computed: {
		computedColor() {
			return this.color || this.contentItems[this.type].color;
		},
	},
	directives: {
		linkify,
	},
};
</script>

<style lang="scss" scoped>
.content {
	position: relative;
	&--overline {
		margin-bottom: 6px;
	}
	&--title {
		margin-bottom: 8px;
	}
	&--body {
		min-height: 72px;
		margin-bottom: 16px;
	}
	&--caption {
		margin-bottom: 8px;
	}
}
</style>
